import {defineMessages} from 'react-intl';

export const ValueScoreMessages = defineMessages({
  BestValue: {
    id: 'ValueScore.bestValue',
    defaultMessage: 'Best',
  },
  GreatValue: {
    id: 'ValueScore.greatValue',
    defaultMessage: 'Great',
  },
  GoodValue: {
    id: 'ValueScore.goodValue',
    defaultMessage: 'Good',
  },
  Value: {
    id: 'ValueScore.value',
    defaultMessage: 'Value',
  },
});
